

export class VehicleCompanyUpdateInput implements IVehicleCompanyUpdateInput {
    /** The auto-generated id of the vehicle company master */
    vehicleCompanyId!: number;
    /** The vehicle company  name with 255 character limit */
    vehicleCompanyName!: string;

    constructor(data?: IVehicleCompanyUpdateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vehicleCompanyId = _data["vehicleCompanyId"];
            this.vehicleCompanyName = _data["vehicleCompanyName"];
        }
    }

    static fromJS(data: any): VehicleCompanyUpdateInput {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleCompanyUpdateInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vehicleCompanyId"] = this.vehicleCompanyId;
        data["vehicleCompanyName"] = this.vehicleCompanyName;
        return data; 
    }
}

export interface IVehicleCompanyUpdateInput {
    /** The auto-generated id of the vehicle company master */
    vehicleCompanyId: number;
    /** The vehicle company  name with 255 character limit */
    vehicleCompanyName: string;
}

